import { Link } from "react-router-dom";
import WavyDivider from "./WavyDivider";
import { Reveal } from "./Reveal";
import { WateringCan, Bee, SproutDoodle } from "./Doodles";

export default function CTABand({ top = "#FFF8EC", bottom = "#3D3229", title = "Come see where your child will grow.", note = "Spots are limited." }) {
    return (
        <section aria-labelledby="cta-band-heading">
            <div style={{ background: top }}>
                <WavyDivider fill="#8FB38A" />
            </div>
            <div className="relative bg-sage text-soil px-5 sm:px-8 py-14 md:py-20 overflow-x-clip">
                <WateringCan className="absolute left-6 bottom-8 opacity-90 hidden md:block" />
                <Bee className="absolute right-8 top-8 hidden md:block" />
                <div className="hidden md:flex gap-1 absolute left-1/2 -translate-x-1/2 bottom-5" aria-hidden="true">
                    {[0, 1, 2, 3, 4].map((i) => (
                        <SproutDoodle key={i} size={26} className={i % 2 ? "opacity-70" : ""} />
                    ))}
                </div>
                <div className="relative max-w-3xl mx-auto text-center">
                    <Reveal>
                        <h2 id="cta-band-heading" className="font-display font-semibold text-3xl md:text-5xl leading-tight text-balance">
                            {title}
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <Link
                            to="/contact"
                            data-testid="cta-band-schedule-tour-button"
                            className="inline-block mt-7 bg-sun text-soil font-extrabold text-lg px-9 py-4 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all"
                        >
                            Schedule a Tour
                        </Link>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <p className="mt-4 font-bold text-soil/80 text-sm">{note}</p>
                    </Reveal>
                </div>
            </div>
            <div className="bg-sage">
                <WavyDivider fill={bottom} flip />
            </div>
        </section>
    );
}
